import { LayoutGrid, ShieldCheck } from 'lucide-react';
import type { SideRailItem } from '@vizial-ui/components';

export interface NavItem extends SideRailItem {
  path?: string;
}

export const NAV_ITEMS: NavItem[] = [
  {
    key: 'all-modules',
    label: 'All Module',
    icon: LayoutGrid,
    section: 'ALL MODULES',
    path: '/',
  },
  {
    key: 'connectivity',
    label: 'Connectivity',
    icon: ShieldCheck,
    section: 'SERVICE INSIGHTS',
    path: '/connectivity/dashboard',
  },
];
